import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { GetWGSTenant } from '../../../../models/wgs.model';

@Component({
  selector: 'dd-wgs-end-user-details',
  templateUrl: './wgs-end-user-detail.component.html',
  styleUrls: ['./wgs-end-user-detail.component.css']
})
export class WGSEndUserDetailsComponent implements OnInit, OnDestroy {

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  private _details = new BehaviorSubject<GetWGSTenant>(null);

  @Input() isSubscriptionResponseLoading: boolean;
  @Input() set details(value: GetWGSTenant) { 
    this._details.next(value); 
  };

  get details() {
    return this._details.getValue();
  }
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
  }

  public editEndUserDetail(event): void {
    event.preventDefault();
    this.router.navigate(['EditWGSEndUser'], { relativeTo: this.activatedRoute });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
